import axios from 'axios'

import { getImageUploadUrl } from '@flecto/api/shared'

import { base64ToBlob } from '..'

export async function uploadImageByBase64(base64: string | undefined) {
  if (!base64) {
    return { id: null, urlTemporary: null }
  }

  const { upload_url } = await getImageUploadUrl()

  const form = new FormData()
  const blob = base64ToBlob(base64)

  if (blob) {
    form.append('file', blob)
  }

  const responseCloudflare = await axios.post(upload_url, form)

  const id = responseCloudflare?.data?.result?.id ?? null
  const urlTemporary = responseCloudflare?.data?.result?.variants?.[0] ?? null

  return { id, urlTemporary }
}
